<template>
	<!-- <InfoButton @click="showOverlay" /> -->
	<GalleryOverlay :scrollHint="showScrollHint()" v-if="overlayVisible" @click="hideOverlay" />
	<div v-if="te('gallery')" class="container-fluid h-100 w-100">
		<div class="modal modal-galerij museum-modal" data-bs-backdrop="false" id="galerijModal" tabindex="-1">
			<div class="modal-dialog modal-dialog-galerij">
				<div class="modal-content modal-content-galerij">
					<div class="modal-body p-0">
						<div id="galerijCarousel" class="carousel h-100" data-bs-ride="carousel" data-bs-touch="true" data-bs-interval="false">
							<div class="carousel-inner h-100">
								<div class="carousel-item h-100" :class="{active: index === 0 }" v-for="(image, index) in tm(`gallery[${$route.params.id}].gallery`)" :key="image">
									<GalleryLayout1 v-if="t(`gallery[${$route.params.id}].layout`) == 'layout1'" :title="image.title" :display_title="display_title" :url="image.url" :description="image.description" />
									<GalleryLayout2 v-if="t(`gallery[${$route.params.id}].layout`) == 'layout2'" :title="image.title" :display_title="display_title" :url="image.url" :description="image.description" />
								</div>
							</div>
							<div class="gallery-btn gallery-close-btn" @click="closeModal">
								<img class="gallery-btn-img" src="~@/assets/img/exit.svg" />
							</div>
							<div class="gallery-btn gallery-left-btn galerij-prev-btn" @click="previousImage">
								<img class="gallery-btn-img" src="~@/assets/img/prev.svg" />
							</div>
							<div class="gallery-btn gallery-right-btn galerij-next-btn" @click="nextImage">
								<img class="gallery-btn-img" src="~@/assets/img/next.svg" />
							</div>
						</div>
						<h1 class="image-number">{{CurrentImage}}/{{TotalImages}}</h1>
					</div>
				</div>
			</div>
		</div>
		<BackButton :text="t('back_button.overview')" />
		<h3 class="text-center museum-titel-test">{{ t(`gallery[${$route.params.id}].post_title`) }}</h3>
		<div class="d-flex">
			<div class="gallery-grid mx-auto museum-footer-mbs">
				<transition-group enter-active-class="animate__fadeIn" leave-active-class="animate__fadeOut">
					<GalleryItem :Overlay="index == 0 && overlayVisible" class="galerij-afbeelding" :image="image.thumbnail" v-for="(image, index) in tm(`gallery[${$route.params.id}].gallery`)" :display_title="display_title" :title="image.title" :key="image" @click="openModal(index)" />
				</transition-group>
			</div>
		</div>
	</div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { useRoute } from 'vue-router';
import { Carousel, Modal } from "bootstrap";
import BackButton from "@/components/buttons/BackButton.vue";
import GalleryItem from "@/components/gallery/GalleryItem.vue";
import GalleryLayout1 from "@/components/gallery/Layout1.vue";
import GalleryLayout2 from "@/components/gallery/Layout2.vue";
import GalleryOverlay from "@/components/gallery/GalleryOverlay.vue";
import InfoButton from "@/components/buttons/InfoButton.vue";

export default {
	name: "Gallery",
	components: {
		BackButton,
		GalleryItem,
		GalleryLayout1,
		GalleryLayout2,
		GalleryOverlay,
		InfoButton,
	},
	setup() {
		const { t, te, tm } = useI18n();
		return { t, te, tm };
	},
	computed: {
		display_title: () => {
			const { t, tm } = useI18n();
			const route = useRoute();  

			let galleries = tm('gallery');

			return galleries[route.params.id].display_title;
		}
	},
	data() {
		return {
			Carousel: null,
			Modal: null,
			TotalImages: 1,
			CurrentImage: 1,
			Sliding: false,
		};
	},
	mounted() {
		const { tm } = useI18n();

		this.Carousel = new Carousel(document.getElementById("galerijCarousel"));
		this.Modal = new Modal(document.getElementById("galerijModal"));
		this.TotalImages = tm(`gallery[${this.$route.params.id}].gallery`).length;

		// Setup slide events
		document.getElementById("galerijCarousel").addEventListener("slide.bs.carousel", this.startSlide);
		document.getElementById("galerijCarousel").addEventListener("slid.bs.carousel", this.endSlide);
	},
	methods: {
		startSlide(event) {
			// Set sliding to true to prevent the user from screwing shit up :)
			this.Sliding = true;
			this.CurrentImage = event.to + 1;
		},
		endSlide(event) {
			this.Sliding = false;
		},
		nextImage(event) {
			if (this.Carousel && !this.Sliding) {
				this.Carousel.next();
				event.stopPropagation();
			}
		},
		previousImage(event) {
			if (this.Carousel && !this.Sliding) {
				this.Carousel.prev();
				event.stopPropagation();
			}
		},
		closeModal(event) {
			if (this.Modal) {
				this.Modal.hide();
			}
		},
		openModal(index) {
			if (this.Modal) {
				this.CurrentImage = index + 1;
				this.Carousel.to(index);
				this.Modal.show();
			}
		},
	},
};
</script>

<style scoped>
.gallery-grid {
	margin-top: 240px;
	display: grid;
	grid-template-columns: 500px 500px 500px;
	column-gap: 80px;
	row-gap: 50px;
}

.gallery-item {
	height: 274px;
	width: 500px;
}

.gallery-btn {
	position: absolute;
	background-color: #1F1F1F;
	width: 99px;
	height: 99px;
}

.gallery-left-btn {
	left: 0;
	top: 45%;
}

.gallery-right-btn {
	right: 0;
	top: 45%;
}

.gallery-close-btn {
	right: 0;
	top: 0;
}

.gallery-btn-img {
	position: absolute;
	height: 60px;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	margin: auto;
}

.image-number {
	position: absolute;
	top: 30px;
	right: 180px;
	text-align: right;
	color: #fff;
}

.image-title {
	position: absolute;
	top: 40px;
	text-align: center;
	left: 50px;
	right: 50px;
	color: #fff;
	font-size: 3.5em;
}

.image-description {
	position: absolute;
	left: 50px;
	right: 50px;
	text-align: center;
	bottom: 50px;
	color: #fff;
}
</style>